import * as Yup from 'yup'

import { Warning } from '@const/translations'

export default Yup.object().shape({
  oguid: Yup.string()
    .uuid(Warning.id)
    .required(Warning.required)
})
